export default (min = 0, max = 9) => min + Math.round(Math.random()) * (max - min);
//# sourceMappingURL=randomInt.mjs.map